import { Pipe, PipeTransform } from '@angular/core';
import { CommercialContract } from '../models/commercial-contract.model';
@Pipe({
    name: 'contractDisplay'
})

export class ContractDisplay implements PipeTransform {

    transform(contract?: CommercialContract): any {
        if (contract) {
            return `${contract.name} (${contract.code})`;
        }
        return contract;
    }
}
